const logDev = false;

// Helper function:
const isRequired = () => {
  throw Error('Parameter is required');
};

// Class for hike map data layer:
export default class HikeMapLayer {
    constructor(name) {
        this.layerName = name; // name of the layer
        this.hikeYears = []; // array of years stored in this layer
        this.hikeTypes = []; // array of types stored in this layer
        this.sumDist = 0.0; // sum of distance
        this.sumElev = 0.0; // sum of elevation gain
        this.sumDistByType = {}; // sum of distance, indexed by type
        this.sumElevByType = {}; // sum of elevation gain, indexed by type
        this.sumDistByYear = {}; // sum of distance, indexed by year
        this.sumElevByYear = {}; // sum of elevation gain, indexed by year
        this.hikeCoords = []; // array of lat,long coordinates for each hike
        this.bubbles = []; // array of pop-up bubbles for each hike coordinate
        this.markers = [];
        this.arrayOfMarkersByType = {}; // array of markers, indexed by type
        this.arrayOfMarkersByYear = {}; // array of markers, indexed by year
    }
    getName() {
      return this.layerName;
    }
    // Added setName method to make tests consistent
    setName(name) {
      this.layerName = name;
    }
    getCoords() {
        return this.hikeCoords;
    }
    getBubbles() {
        return this.bubbles;
    }
    getDist() {
      return this.sumDist;
    }
    getElev() {
      return this.sumElev;
    }
    getSumDistType(t) {
      if(this.sumDistByType[t] == null)  return 0.0;
      else return this.sumDistByType[t];
    }
    getSumElevType(t) {
      if(this.sumElevByType[t] === undefined) return 0.0;
      else return this.sumElevByType[t];
    }
    getSumDistYear(y) {
      if(this.sumDistByYear[y] == null)  return 0.0;
      else return this.sumDistByYear[y];
    }
    getSumElevYear(y) {
      if(this.sumElevByYear[y] === undefined) return 0.0;
      else return this.sumElevByYear[y];
    }
    getMarkers() {
      return this.markers;
    }
    getArrayOfMarkersSingleYear(year) {
      return this.arrayOfMarkersByYear[year];
    }
    getArrayOfMarkersSingleType(type) {
      return this.arrayOfMarkersByType[type];
    }
    getArrayOfAllMarkersByYear() {
      let retArrayAllMarkers = [];
      this.hikeYears.forEach(year => {
        retArrayAllMarkers = retArrayAllMarkers.concat(this.arrayOfMarkersByYear[year]);
      });
      return retArrayAllMarkers;
    }
    getArrayOfAllMarkersBySingleYear(year) {
      return this.arrayOfMarkersByYear[year];
    }
    getArrayOfAllMarkersByType() {
      let retArrayAllMarkers = [];
      this.hikeTypes.forEach(type => {
        retArrayAllMarkers = retArrayAllMarkers.concat(this.arrayOfMarkersByType[type]);
      });
      return retArrayAllMarkers;
    }
    getArrayOfAllMarkersBySingleType(type) {
      return this.arrayOfMarkersByType[type];
    }
   
    addHike(type = isRequired(), year = isRequired(), lat, long, dist = isRequired(), elev = isRequired(), title = isRequired(), html, marker) {
      if (logDev) {
        console.log("HikeMapLayer > addHike called for: ", title);
      }
      // sanity check:
      if(type == null || type === "" || year == null || year < 2012 || dist < 0 || elev < 0 || !Number.isFinite(lat) || !Number.isFinite(long) || title == null || title === "") {
        if (logDev) {
          console.log("HikeMapLayer > ERROR > addHike sanity check failed for: " + title);
        }
        return false;
      }
      
      if(this.hikeYears.indexOf(year)<0) {
        this.hikeYears.push(year);
      }

      if(this.hikeTypes.indexOf(type)<0) {
        this.hikeTypes.push(type);
      }

      this.hikeCoords.push({
        lat: lat,
        lon: long
      });

      this.bubbles.push({
        type: type,
        lat: lat,
        lon: long,
        title: title,
        html: html,
        visible: true
      });

      // Add this hike's distance to the layer's total distance tracker:
      this.sumDist += dist;
      // Add this hike's elev gain to the layer's total elev gain tracker:
      this.sumElev += elev;
      // Add this hike's distance to the type and year-specific total distance tracker:
      if(this.sumDistByYear[year] == null) {
        this.sumDistByYear[year] = dist;
      } else {
        this.sumDistByYear[year] += dist;
      }
      if(this.sumDistByType[type] == null) {
        this.sumDistByType[type] = dist;
      } else {
        this.sumDistByType[type] += dist;
      }
      // Add this hike's elev gain to the type and year-specific total elev gain tracker:
      if(this.sumElevByYear[year] == null) {
        this.sumElevByYear[year] = elev;
      } else {
        this.sumElevByYear[year] += elev;
      }
      if(this.sumElevByType[type] == null) {
        this.sumElevByType[type] = elev;
      } else {
        this.sumElevByType[type] += elev;
      }

      if(!Array.isArray(this.arrayOfMarkersByType[type])) {
        // initialize this type's array and add its first marker:
        this.arrayOfMarkersByType[type] = [marker];
      } else {
        this.arrayOfMarkersByType[type].push(marker);
      }
      if(!Array.isArray(this.arrayOfMarkersByYear[year])) {
        // initialize this year's array and add its first marker:
        this.arrayOfMarkersByYear[year] = [marker];
      } else {
        this.arrayOfMarkersByYear[year].push(marker);
      }
      this.markers.push(marker);
    
      return true;
    }
}
